export default __webpack_public_path__ + "static/google-live-typing-3685d46a3421c8f0dcaad5c23107ac01.png";